
import {
  GAME_SPINNERS_ACTIVE,
  GAME_SPINNERS_NEW,
  GAME_SPINNERS_JOINED,
  GAME_SPINNERS_LOCK,
  GAME_SPINNERS_ROLL,
  GAME_SPINNERS_EXPIRED,
  GAME_SPINNERS_WON,
} from '@/utils/constants/socket-events'

import SpinnersGame from '@/store/models/games/spinners/SpinnersGame'
import { GAME_STATUS } from '@/views/games/Spinners/utils'
import { registerSound } from '@/modules/sound'
import i18n from '@/plugins/i18n'

const winSound = registerSound('games/wheel/win')

export default {
  [`SOCKET_${GAME_SPINNERS_ACTIVE}`]({ commit }, games) {
    SpinnersGame.create({ data: games })
  },
  [`SOCKET_${GAME_SPINNERS_NEW}`]({ commit }, game) {
    SpinnersGame.insert({ data: game })
  },
  [`SOCKET_${GAME_SPINNERS_JOINED}`]({ commit }, { id, player }) {
    SpinnersGame.update({
      where: id,
      data(record) {
        record.players[player.steamid] = player
      },
    })
  },
  [`SOCKET_${GAME_SPINNERS_LOCK}`]({ commit }, { id, fairness }) {
    SpinnersGame.update({
      where: id,
      data(record) {
        record.status = GAME_STATUS.locked
        record.fairness = fairness
      },
    })
  },
  [`SOCKET_${GAME_SPINNERS_ROLL}`]({ commit }, game) {
    SpinnersGame.update({
      where: game.id,
      data(record) {
        record.status = GAME_STATUS.complete
        record.fairness = game.fairness
        record.outcome = game.outcome
        record.rolledAt = new Date().toISOString()
        record.rolledAtDifferenceMs = 0
        record.data = game.data
      },
    })
  },
  // TODO remove this entirely tbh
  [`SOCKET_${GAME_SPINNERS_WON}`]({ commit }, { id, won }) {
    const { _vm: vm } = this

    const { toScrap } = vm.$options.filters

    // NOTE gleam
    const Gleam = window.Gleam || []
    Gleam.push(['spinners-win-ip7qG9V9AEaoG', ''])

    vm.$toast.success(
      i18n.tc('common.won_scrap', toScrap(won)),
      {
        title: i18n.t('common.games.spinners'),
        sound: winSound,
      },
    )
  },
  [`SOCKET_${GAME_SPINNERS_EXPIRED}`]({ commit }, ids) {
    SpinnersGame.delete(game => ids.includes(game.id))
  },
}
